<script>
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import ApiClass from "../../api/api";
import Swal from "sweetalert2";
import Editor from '@tinymce/tinymce-vue';

/**
 * Editors component
 */
export default {
    page: {
        title: "Edit BLog",
        meta: [{
            name: "description",
            description: appConfig.description
        }],
    },
    components: {
        Layout,
        PageHeader,
        Multiselect,
        Editor
    },
    data() {
        return {
            categories: [],
            valid: true,
            submitted: false,
            title: "Edit Blog",
            items: [{
                    text: "Blog",
                    href: "#",
                },
                {
                    text: "Edit Blog",
                    active: true,
                },
            ],
            editid: null,
            editData: {},
            blog_name: '',
            category: null,
            image: "",
            new_image: "",
            date: '',
            description: "",
            plugins: [
                "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
                "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
                "save table contextmenu directionality emoticons template paste textcolor imagetools",
            ],
            toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons",
            options: {
                height: 300,
                style_formats: [{
                        title: "Bold text",
                        inline: "b"
                    },
                    {
                        title: "Red text",
                        inline: "span",
                        styles: {
                            color: "#ff0000"
                        }
                    },
                    {
                        title: "Red header",
                        block: "h1",
                        styles: {
                            color: "#ff0000"
                        }
                    },
                    {
                        title: "Example 1",
                        inline: "span",
                        classes: "example1"
                    },
                    {
                        title: "Example 2",
                        inline: "span",
                        classes: "example2"
                    },
                    {
                        title: "Table styles"
                    },
                    {
                        title: "Table row 1",
                        selector: "tr",
                        classes: "tablerow1"
                    },
                ],
            },
        };
    },
    mounted() {
        if (this.$route.query) {
            this.editid = this.$route.query.id;
            //console.log(this.editid);
            this.getBlog();

        }
    },
    created() {
        this.getCategories();
    },
    validations: {
        category: {
            required,
        },
        blog_name: {
            required,
        },
        date: {
            required
        },
        description: {
            required,
        },
    },
    methods: {
        async getCategories() {
            let response = await ApiClass.getNodeRequest('category/get');
            if (response.data.status_code == 1) {
                this.categories = response.data.data.data;
               
            }
        },
        async getBlog() {
            var response = await ApiClass.getNodeRequest('blog/get?id=' + this.editid);
            //console.log({ response });
            if (response.data.status_code == 1) {
                this.editData = response.data.data;
                this.description = this.editData.description;
                this.blog_name = this.editData.name;
                this.date = (new Date(this.editData.publish_at).toISOString()).slice(0, 10);
                this.image = this.editData.image
                this.category = this.editData.category
            }
        },
        onChangeImage(e) {
            this.new_image = e.target.files[0];
            this.image = URL.createObjectURL(e.target.files[0]);
        },
        async imageUpload(){
             let imageData =new FormData();
             imageData.append("file", this.new_image);
             let header = { "Content-Type": 'multipart/form-data;'};
             var result = await ApiClass.postNodeRequest("blog/imageupload", false, imageData,header);
             console.log({result});
             return result.data.data;
        },
        async save() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
             let image_name = this.image.split('/')
                image_name = this.new_image? await this.imageUpload():image_name[image_name.length-1];
            var obj = {
                category_id: this.category.id,
                name: this.blog_name,
                publish_at: this.date,
                description: this.description,
                image:image_name
            }
             
            var result = await ApiClass.updatenodeRequest("blog/update/" + this.editData.id, false, obj);
            this.submitted = false;
            if (result.data.status_code == 1) {
                this.category = this.blog_name = this.description = this.new_image = this.image = this.date = "";
                return Swal.fire({
                    position: "center",
                    icon: "success",
                    title: result.data.message,
                    showConfirmButton: false,
                    timer: 1000,
                });
            }
            Swal.fire({
                position: "center",
                icon: "error",
                title: result.data.message,
                showConfirmButton: false,
                timer: 1000,
            })
        },
        onReset(event) {
            event.preventDefault();
            this.submitted = false;
            this.category = this.blog_name = this.description = this.new_image = this.image = this.date = ""; // Empty Fields
        },
    },
};
</script>

<template>
<Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <form @submit.prevent="save" @reset="onReset">
                        <!-- Name-->

                        <div class="form-group" :class="{ 'form-group--error': $v.blog_name.$error }">
                            <p class="mb-2 mt-3">Blog Name:</p>
                            <input v-model.trim="$v.blog_name.$model" class="form-control text-capitalize" type="text" placeholder="Blog Name" aria-label="default input example" />

                        </div>
                        <div class="error" v-if="submitted && !$v.blog_name.required">Blog Name is required</div>

                        <!-- Category -->
                        <div class="form-group" :class="{ 'form-group--error': $v.category.$error }">
                            <p class="mb-2 mt-3 ">Category:</p>
                            <multiselect v-model.trim="$v.category.$model" track-by="id" label="name" :options="categories" required></multiselect>
                        </div>
                        <div class="error" v-if="submitted && !$v.category.required">
                            Category is required
                        </div>

                        <!-- Publish At -->
                        <div class="form-group" :class="{ 'form-group--error': $v.date.$error }">
                            <p class="mt-3 mb-2">Publish At</p>
                            <div class="input-group date" id="datepicker">
                                <input type="date" class="form-control" id="date" v-model="date" />
                            </div>
                        </div>
                        <div class="error" v-if="submitted && !$v.date.required">
                            Date is required
                        </div>

                        <!-- Image -->
                        <div class="form-group">
                            <p class="mb-2 mt-3">Image:</p>
                            <div>
                                <small class="text-muted ">
                                    <strong>Note :- </strong>
                                    <span class="text-danger">1. Only JPG,JPEG,PNG Image. </span></small>
                                <input class="form-control" ref="fileupload" type="file" id="formFile" accept="image/*" @change="onChangeImage" />
                            </div>
                        </div>
                        <!--col-5 choose-image-->

                        <div class="col-xl-1 col-lg-1 col-md-1 col-2 mb-3">
                            <div class="form-group">
                                <div class="currency-image">
                                    <img :src="image" alt="" class="img-fluid" />
                                </div>
                            </div>
                            <!--form-group-->
                        </div>

                        <!-- Text Editor -->
                        <div class="form-group" :class="{ 'form-group--error': $v.description.$error }">
                            <p class="mb-2 mt-3">Add Description :</p>

                            <Editor id="d1" v-model.trim="$v.description.$model" :init="options" :plugins="plugins" :toolbar="toolbar"></Editor>
                        </div>
                        <div class="error" v-if="submitted && !$v.description.required">
                            Description is required
                        </div>

                        <!-- Save Button -->
                        <b-button class="mt-3 me-3" type="submit" variant="primary">Submit</b-button>
                        <b-button class="mt-3" type="reset" variant="danger">Reset</b-button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</Layout>
</template>
